export default __webpack_public_path__ + "static/waiting-2bfa0a1e9b2719e1fd3c1baa3c5526ca.svg";